import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { SearchResult } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-search-recents',
    templateUrl: './search-recents.component.html',
    styleUrls: ['./search-recents.component.scss']
})
export class SearchRecentsComponent {
    @Input() recents: SearchResult[] = [];
    @Input() searchText: string;
    @Output() clear: EventEmitter<void> = new EventEmitter<void>();
    @Output() select: EventEmitter<SearchResult> = new EventEmitter<SearchResult>();

    constructor(@Inject('ENV') public env: Env) {}
}
